export const INVITE_OFFER_COOKIE = {
  AutoAccept: 'acceptInviteOfferAutoAccept',
  CommunicationMethod: 'acceptInviteOfferCommunicationMethod',
  JobPositionId: 'acceptInviteOfferJobPositionId',
  MatchId: 'acceptInviteOfferMatchId',
  Time: 'acceptInviteOfferTime',
} as const;
